import oidcJS from '../public/oidcRoot'
import commonJs from '../public/common'
import axios from 'axios'
// import Qs from 'qs'  //引入qs  时axios的自带模块
import {handleError} from '../public/error-info'
import router from "../router/index";
import { MessageBox} from 'element-ui'

const axiosInstance = axios.create();//创建axios实例 超时时间

const developerService = process.env.DEVELOPER_SERVICE;    //开发者中心网关




let ajaxErrorBool = true;//axios发生错误的请求（401,403,500）
//白名单（不加loading效果）
let whiteList1 = [
  '/Image',
]
//白名单（不加authorization  eg：登录注册等）
let whiteList2 = [
  '/register',
  '/documentation'
]
// http request 拦截器
axiosInstance.interceptors.request.use(
  config => {   //在请求发出之前进行一些操作
    let blackBool = true;//默认使用loading
    let whiteList2Bool = true;//默认加token
    // loading 关闭
    commonJs.finishLoading();

    //白名单不加loading效果
    for(var i = 0;i<whiteList1.length;i++){
      if (config.url.toLocaleLowerCase().indexOf(whiteList1[i].toLocaleLowerCase()) != -1) {
        blackBool = false;
        break
      }
    }
    if(blackBool){
      // loading 开始
      commonJs.beginLoading()
    }
    //白名单不加loading效果
    for(var i = 0;i<whiteList2.length;i++){
      if (config.url.toLocaleLowerCase().indexOf(whiteList2[i].toLocaleLowerCase()) != -1) {
        whiteList2Bool = false;
        break
      }
    }
    //白名单不加token
    if(whiteList2Bool){
      if (!commonJs.getLocalstorage('accessToken','12')) {    //没有用户标识  即需要用户去登陆
        console.log('48行',config.url.toLocaleLowerCase())
        if(config.url != developerService + '/accounts'){
          oidcJS.utils.login(); //调用父级方法登录
        }
      } else {
        config.headers['authorization'] = "Bearer " + commonJs.getLocalstorage('accessToken','12');      //有用户标识 则将用户标识符设置为请求头
      }
    }
    config.startTime = +new Date
    return config
  },
  error => {
    MessageBox.alert(error, '接口请求错误', {
      confirmButtonText: '确定',
    });
    if (!!error) {
      return Promise.reject(error);
    }
  }
)

/**
 * http response 拦截器
 * resp.data.code:
 *    403: 无权限
 *    401：登录无效
 *    200：成功，正常
 */
axiosInstance.interceptors.response.use(
  resp => {     //在这里对返回的数据进行处理
    // loading 关闭
    commonJs.finishLoading();

    resp.config.duration = +new Date - resp.config.startTime
    if(resp.config.duration>=3000){
      //  1.判断请求超时
      if(localStorage['timeoutUrl']){
        let arr = JSON.parse(localStorage['timeoutUrl'])
        arr.push(resp.config.url)
        let timeoutUrl = new Set(arr)
        localStorage['timeoutUrl'] = JSON.stringify(timeoutUrl)
      }else{
        let arr = []
        arr.push(resp.config.url)
        localStorage['timeoutUrl'] = JSON.stringify(arr)
      }
      // console.log('根据你设置的timeout请求超时 判断请求现在超时了，超时接口为：'+localStorage['timeoutUrl'])
    }
    // console.log(resp)
    return Promise.resolve(resp);
  },
  error => {
    error.config.duration = +new Date - error.config.startTime
    console.log(error)
    // loading 关闭
    commonJs.finishLoading();
    // 只用于授权报错的特殊处理，其他项目不需要这个判断
    if(localStorage['authTokenUrl'] && localStorage['authTokenUrl']===error.config.url){
      MessageBox.alert('您当前授权信息已失效，请重新授权', '提示', {
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        router.push('/applicationList')
      }).catch(() => {
        router.push('/applicationList')
      });
    }
    //  1.判断请求超时
    if(error.config.duration>=3000){
      if(localStorage['timeoutUrl']){
        let arr = JSON.parse(localStorage['timeoutUrl'])
        arr.push(error.config.url)
        let timeoutUrl = new Set(arr)
        localStorage['timeoutUrl'] = JSON.stringify(timeoutUrl)
      }else{
        let arr = []
        arr.push(error.config.url)
        localStorage['timeoutUrl'] = JSON.stringify(arr)
      }
      // console.log('根据你设置的timeout请求超时 判断请求现在超时了，超时接口为：'+localStorage['timeoutUrl'])
    }
    if(ajaxErrorBool){
      if (error.response.status == 403) {
        ajaxErrorBool = false;
        //后台返回登录超时   则置空缓存中的用户标识 并登录
        MessageBox.confirm('您当前没有访问当前页面的权限，请尝试重新登录或联系管理员', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          oidcJS.utils.login(); //调用父级方法登录
        }).catch(() => {
          if(error.config.url != developerService + '/accounts'){
            oidcJS.utils.login(); //调用父级方法登录
          }
        });

      } else if (error.response.status == 401) {
        console.log('134行',error.config.url.toLocaleLowerCase())
        ajaxErrorBool = false;
        if(error.config.url != developerService + '/accounts'){
          //后台返回登录超时   则置空缓存中的用户标识 并登录
          MessageBox.confirm('系统检测到您当前未登录或当前登录信息已过期，可尝试重新登录', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            oidcJS.utils.login(); //调用父级方法登录
          }).catch(() => {
            if(error.config.url != developerService + '/accounts'){
              oidcJS.utils.login(); //调用父级方法登录
            }
          });
        }

      }
    }
    if (error.response.status == 500) {
      console.log(error.response.data)
      commonJs.toError(error.response.data.Errors[0].Message)
    } else {
      handleError(error.response.data)
    }

    return Promise.reject(error);
  }
);
export default {
  post(url, data, responseType,gateway) {     //post请求
    if (url.indexOf('http') == -1){
      if(gateway == 'developerService'){
        url = developerService + url;
      }else{
        url = developerService + url;
      }
    }
    var obj = {
      method: 'post',
      url,
      data,
      // timeout: 60000,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json; charset=UTF-8',
      }
    }, params = {};
    if (responseType)
      params = Object.assign(obj, {responseType: 'blob'});//请求文件流
    else
      params = obj;
    return axiosInstance(params);
  },
  postForm(url, data,gateway) {     //post请求
    if (url.indexOf('http') == -1){
      if(gateway == 'developerService'){
        url = developerService + url;
      }else{
        url = developerService + url;
      }
    }
    var obj = {
      method: 'post',
      url,
      transformRequest: [function(data) {//在请求之前对data传参进行格式转换
        let ret = ''
        for (let item in data){
          ret += encodeURIComponent(item) + '=' + encodeURIComponent(data[item]) + '&'
        }
        ret = ret.slice(0,ret.length-1)
        return ret
      }],
      // transformRequest: [function(data) {//在请求之前对data传参进行格式转换
      //   data = Qs.stringify(data)
      //   return data
      // }],
      data:data,
      // timeout: 60000,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      }
    },
    params = obj;
    return axiosInstance(params);
  },

  get(url, params,gateway) {        //get请求
    if (url.indexOf('http') == -1){
      if(gateway == 'developerService'){
        url = developerService + url;
      }else{
        url = developerService + url;
      }
    }
    var obj = {
      method: 'get',
      url,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      }
    };
    if (params) obj.params = params;
    return axiosInstance(obj);
  },

  delete(url, data,gateway) {        //delete请求
    if (url.indexOf('http') == -1){
      if(gateway == 'developerService'){
        url = developerService + url;
      }else{
        url = developerService + url;
      }
    }
    var obj = {
      method: 'delete',
      url,
      data,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json; charset=UTF-8'
      }
    };
    // if (params) obj.params = params;
    return axiosInstance(obj);
  },

  put(url, data,gateway) {        //put请求
    if (url.indexOf('http') == -1){
      if(gateway == 'developerService'){
        url = developerService + url;
      }else{
        url = developerService + url;
      }
    }
    return axiosInstance({
      method: 'put',
      url,
      data,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json; charset=UTF-8',
        // 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/public/ajax.js